export const firebaseConfig = {
  "projectId": "studio-4617923657-a8cda",
  "appId": "1:228543204937:web:c78070638caa8feb13f998",
  "apiKey": "AIzaSyBKvFEyDSBLNIO9k2eCWDWZVEfz27R99CU",
  "authDomain": "studio-4617923657-a8cda.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "228543204937"
};
